export default __webpack_public_path__ + "15f5e52fe5086163c4e20545d0665f16.svg";